/**
 * Web Style Import
 *
 */

import './style/dnb-form-label.scss'
